import { Befehl27 } from '../../../models'
import {
  Befehl27FormData,
  Befehl27FormSchema
} from './schema/befehl27-form.schema'
import {
  Befehl27DataDto,
  BefehlAuftrag_27_10Dto,
  Feld_27_11Dto,
  Feld_27_12Dto
} from '../../../dtos/befehl-27-dto'
import {
  findAuftragByKennung,
  createZugmeldestelleField
} from '../converter-utils'

export const convertModelToBefehl27FormData = (
  befehl?: Befehl27
): Befehl27FormData => {
  const formData = Befehl27FormSchema.parse({})

  if (!befehl?.auftraege) {
    return formData
  }

  const auftrag2710 = findAuftragByKennung(
    befehl.auftraege,
    '27.10'
  ) as BefehlAuftrag_27_10Dto
  if (auftrag2710) {
    // Auftrag 27.10 is always enabled
    formData.auftrag27_10.enabled = true

    const feld2711 = auftrag2710.felder?.find(
      (feld) => feld.kennung === '27.11'
    ) as Feld_27_11Dto
    if (feld2711?.werte?.zugmeldestelle) {
      formData.auftrag27_10.feld27_11 = {
        art: feld2711.werte.zugmeldestelle.art || '',
        name: feld2711.werte.zugmeldestelle.name || ''
      }
    }

    const feld2712 = auftrag2710.felder?.find(
      (feld) => feld.kennung === '27.12'
    ) as Feld_27_12Dto
    if (feld2712?.werte?.zugmeldestelle) {
      formData.auftrag27_10.feld27_12 = {
        art: feld2712.werte.zugmeldestelle.art || '',
        name: feld2712.werte.zugmeldestelle.name || ''
      }
    }
  }

  return formData
}

export const convertBefehl27FormDataToModel = (
  data: Befehl27FormData,
  frontendId: string
): Befehl27 => {
  // Always include Auftrag 27.10 (it's always enabled by default)
  const auftraege: Befehl27DataDto = [
    {
      kennung: '27.10',
      felder: [
        createZugmeldestelleField(
          '27.11',
          data.auftrag27_10?.feld27_11?.art,
          data.auftrag27_10?.feld27_11?.name
        ),
        createZugmeldestelleField(
          '27.12',
          data.auftrag27_10?.feld27_12?.art,
          data.auftrag27_10?.feld27_12?.name
        )
      ] as Array<Feld_27_11Dto | Feld_27_12Dto>
    }
  ]

  return {
    kennung: '27',
    frontendId,
    auftraege
  }
}
